// Colour correction applies only after a set time in a video. Before that, the
// video plays as filmed. Add data-luuna-split="2.5" (seconds) on the video wrapper.
(function () {
  function setup(root) {
    var video = root.querySelector('video');
    if (!video) return;
    var split = parseFloat(root.getAttribute('data-luuna-split')) || 0;
    var frame = null;
    function apply() {
      root.style.filter = video.currentTime < split ? 'none' : '';
    }
    function tick() {
      apply();
      frame = video.paused ? null : requestAnimationFrame(tick);
    }
    video.addEventListener('play', function () { if (!frame) tick(); });
    video.addEventListener('seeked', apply);
    video.addEventListener('loadeddata', apply);
    apply();
    if (!video.paused) tick();
  }
  function init() {
    document.querySelectorAll('[data-luuna-split]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
